import { PublicClientApplication } from '@azure/msal-browser';

// ===== MSAL CONFIGURATION =====
// Values come from .env file

const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes for login
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// Scopes for API calls to our Function App
export const apiRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
};

// Scopes for Graph API (user photo)
export const graphRequest = {
  scopes: ['User.Read'],
};

// MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
export async function initializeMsal() {
  await msalInstance.initialize();
  const response = await msalInstance.handleRedirectPromise();
  if (response) {
    msalInstance.setActiveAccount(response.account);
  }
  return msalInstance;
}

// Get access token for our API
export async function getApiToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) throw new Error('No active account');

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...apiRequest,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    const response = await msalInstance.acquireTokenPopup(apiRequest);
    return response.accessToken;
  }
}

// Get access token for Graph API
export async function getGraphToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) throw new Error('No active account');

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...graphRequest,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    const response = await msalInstance.acquireTokenPopup(graphRequest);
    return response.accessToken;
  }
}
